export default "__VITE_ASSET__BxfOYsQK__"